module.exports = __webpack_public_path__ + "img/heel_off_chart.3b911b57.png";